module.exports = __webpack_public_path__ + "img/organizacionMob.d9169124.jpg";